import { useThreePointAngleMeasure } from "../../../hooks/useThreePointAngleMeasure"

// @ts-ignore
export const ThreePointAngleMode = () => {
  // eslint-disable-next-line no-empty-pattern
  const {} = useThreePointAngleMeasure()

  return null
}
